import QS from 'qs'
import {useLocation} from "react-router-dom";

export function useQuery() {
  const { search } = useLocation();
  return QS.parse(search);
}
